import { render, staticRenderFns } from "./ModalNotificationUser.vue?vue&type=template&id=03037c0c&scoped=true&"
import script from "./ModalNotificationUser.vue?vue&type=script&lang=js&"
export * from "./ModalNotificationUser.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotificationUser.vue?vue&type=style&index=0&id=03037c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03037c0c",
  null
  
)

export default component.exports